import { forwardRef } from 'react';
import { cn } from '../../lib/cn';
import { Spinner } from './Spinner';

// Jeden komponent przycisku zamiast ~40 miejsc, w których ten sam zestaw klas
// ("inline-flex items-center px-6 py-3 border border-transparent text-base
// font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700
// focus:outline-none focus:ring-2 ...") był wklejany z drobnymi różnicami.

const VARIANTS = {
  primary: 'bg-accent text-accent-content hover:bg-accent-hover',
  secondary: 'border border-line bg-surface text-content hover:border-line-strong hover:bg-elevated',
  ghost: 'text-muted hover:bg-elevated hover:text-content',
  // Warianty destrukcyjne używają stałych odcieni czerwieni zamiast tokenu
  // semantycznego: token `danger` jest dobrany pod TEKST (ciemny w motywie
  // jasnym, jasny w ciemnym), więc jako tło wypadałby raz za ciemno, raz za jasno.
  danger: 'bg-red-600 text-white hover:bg-red-700',
  'danger-soft': 'border border-danger-line bg-danger-soft text-danger hover:bg-danger/15',
  success: 'bg-emerald-600 text-white hover:bg-emerald-700',
};

const SIZES = {
  sm: 'h-8 gap-1.5 px-2.5 text-xs',
  md: 'h-9 gap-2 px-3 text-sm',
  lg: 'h-10 gap-2 px-4 text-sm',
};

export const Button = forwardRef(function Button(
  {
    variant = 'secondary',
    size = 'md',
    icon: Icon,
    iconRight: IconRight,
    loading = false,
    disabled = false,
    className,
    children,
    type = 'button',
    ...props
  },
  ref
) {
  const iconSize = size === 'sm' ? 14 : 16;

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-md font-medium transition-colors',
        'disabled:pointer-events-none disabled:opacity-50',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {loading ? (
        <Spinner size="sm" className="border-current border-t-transparent" />
      ) : (
        Icon && <Icon size={iconSize} className="shrink-0" />
      )}
      {children}
      {IconRight && !loading && <IconRight size={iconSize} className="shrink-0" />}
    </button>
  );
});

export default Button;
